import React from "react";
import styled, { css } from "styled-components";

import { useAppSelector } from "./app/hooks";
import { state } from "./features/gameSlice";
import deskImage from "./assets/desk.png";
import ImageMap from "./ImageMap";

const ImageContainer = styled.div<{ image: string }>`
  background: url(${(props) => props.image});
  background-size: contain;
  background-repeat: no-repeat;
`;

const LevelContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  position: relative;
`;

const LevelImage = styled(ImageContainer)`
  height: 100%;
  width: 100%;
  position: absolute;
`;

const Desk = styled(ImageContainer)`
  height: 100%;
  width: 100%;
  position: absolute;
`;
function LevelBlock() {
  const { level1, level2, level3, level4, level5, level6, level7 } =
    useAppSelector(state);

  return (
    <LevelContainer>
      <Desk image={deskImage} />
      {!level2 && <LevelImage image={ImageMap[level1 || "level1_1"]} />}
      <LevelImage image={ImageMap[`${level1}_${level2}`]} />
      <LevelImage image={ImageMap[level4]} />
      <LevelImage image={ImageMap[level3]} />
      <LevelImage image={ImageMap[level5]} />
      <LevelImage image={ImageMap[level6]} />
      <LevelImage image={level7} />
    </LevelContainer>
  );
}

export default LevelBlock;
